import { ResponseInfo } from '@/config/types';
import { apiConfig } from '@/services/api-config';

export default async function (resp: ResponseInfo) {
  return apiConfig
    .patch('api/TerritoryAccess/response', resp)
    .then((response) => response.data)
    .catch(() => false);
}
